"use client";

import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "disabled", "invalid", "autoFocus"];
import { useFocusRing as E } from "@react-aria/focus";
import { useHover as v } from "@react-aria/interactions";
import { useMemo as A } from "react";
import { useActivePress as g } from '../../hooks/use-active-press.js';
import { useId as _ } from '../../hooks/use-id.js';
import { useDisabled as R } from '../../internal/disabled.js';
import { useProvidedId as D } from '../../internal/id.js';
import { forwardRefWithAs as F, mergeProps as L, useRender as C } from '../../utils/render.js';
import { useDescribedBy as x } from '../description/description.js';
import { useLabelledBy as h } from '../label/label.js';
var H = "select";
function B(a, i) {
  var p = _(),
    d = D(),
    n = R(),
    _a$id = a.id,
    c = _a$id === void 0 ? d || "headlessui-select-".concat(p) : _a$id,
    _a$disabled = a.disabled,
    e = _a$disabled === void 0 ? n || !1 : _a$disabled,
    _a$invalid = a.invalid,
    t = _a$invalid === void 0 ? !1 : _a$invalid,
    _a$autoFocus = a.autoFocus,
    o = _a$autoFocus === void 0 ? !1 : _a$autoFocus,
    f = _objectWithoutProperties(a, _excluded),
    m = h(),
    u = x(),
    _E = E({
      autoFocus: o
    }),
    r = _E.isFocusVisible,
    T = _E.focusProps,
    _v = v({
      isDisabled: e
    }),
    l = _v.isHovered,
    b = _v.hoverProps,
    _g = g({
      disabled: e
    }),
    s = _g.pressed,
    y = _g.pressProps,
    P = L({
      ref: i,
      id: c,
      "aria-labelledby": m,
      "aria-describedby": u,
      "aria-invalid": t ? "" : void 0,
      disabled: e || void 0,
      autoFocus: o
    }, T, b, y),
    S = A(function () {
      return {
        disabled: e,
        invalid: t,
        hover: l,
        focus: r,
        active: s,
        autofocus: o
      };
    }, [e, t, l, r, s, o]);
  return C()({
    ourProps: P,
    theirProps: f,
    slot: S,
    defaultTag: H,
    name: "Select"
  });
}
var j = F(B);
export { j as Select };